function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

const makeSchema = (jobs) => {
  return {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    title: jobs.title,
    description: jobs.desc,
    identifier: {
      "@type": "PropertyValue",
      name: "Fonolive",
      value: "1234567",
    },
    datePosted: jobs.createdAt,
    validThrough: addDays(jobs.createdAt, 60),
    employmentType: "Full_Time",
    hiringOrganization: {
      "@type": "Organization",
      name: jobs.comp_name,
      sameAs: "",
      logo: "",
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: jobs.city,
        addressRegion: jobs.state,
        addressCountry: jobs.country,
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "USD",
      value: {
        "@type": "QuantitativeValue",
        value: jobs.salary,
        unitText: "HOUR",
      },
    },
  };
};

const JobsSchema = ({ jobs }) => {
  return (
    <>
      <script
        id="adsbygoogle-init"
        strategy="afterInteractive"
        async="true"
        crossorigin="anonymous"
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5121538459968588"
      />
      <script
        key={`jobJSON-${jobs.id}`}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(makeSchema(jobs)) }}
      />
    </>
  );
};

export default JobsSchema;
